var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "item-text-wrap route-wrap"
  }, [_c("div", {
    staticClass: "route-content"
  }, _vm._l(_vm.data, function (route) {
    return _c("div", {
      staticClass: "route-text"
    }, [_c("div", {
      staticClass: "wrap"
    }, [_c("span", {
      staticClass: "time"
    }, [_vm._v(_vm._s(route.acceptTime))]), _c("span", {
      staticClass: "status"
    }, [_vm._v("(" + _vm._s(route.state) + ")")])]), _c("div", {
      staticClass: "wrap content"
    }, [_vm._v("(" + _vm._s(route.acceptAddress) + ")" + _vm._s(route.remark))])]);
  }), 0)])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };